import { TAGLink, useAppContext } from '@aspendental/shared-components-web';
import Disclaimer from '@aspendental/shared-components-web/lib/components/Disclaimer';
import { IFooter } from '@aspendental/shared-components-web/lib/components/Footer/Footer';
import RichText, { RichTextContent } from '@aspendental/shared-components-web/lib/components/RichText/RichText';
import { Box, Container, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { contactUsWrapper, copyrightStyles, footerLinkTextBoxDesktopStyles, getAboutWrapperStyles, getContentWrapperStyles, getNavWrapperStyles, getScheduleContainerStyles, getWrapperStyles } from './Footer.styles';
import { PATIENT_SERVICES_BASE_URL } from '@src/constants';
interface FooterProps extends IFooter {
  showDisclaimer?: boolean;
}
export default function Footer({
  footerData,
  showDisclaimer
}: Readonly<FooterProps>) {
  const {
    environment
  } = useAppContext();
  const {
    pathname
  } = useRouter();
  const onPatientServices = pathname.includes(`/${PATIENT_SERVICES_BASE_URL}`);
  const getNavigationLinks = (environment): Array<{
    title: string;
    link: string;
    new_tab: boolean;
  }> => {
    return [{
      title: 'Accessibility',
      link: `https://www${environment === 'prod' ? '' : 'stg'}.aspendental.com/legal/accessibility/`,
      new_tab: true
    }, {
      title: 'Privacy Policy',
      link: `https://www${environment === 'prod' ? '' : 'stg'}.aspendental.com/legal/privacy-policy/`,
      new_tab: true
    }, {
      title: 'Terms of Use',
      link: `https://www${environment === 'prod' ? '' : 'stg'}.aspendental.com/legal/terms-of-use/`,
      new_tab: true
    }];
  };
  const footerLinks = getNavigationLinks(environment);
  return <Box component="footer" data-test-id="section_footer" sx={getWrapperStyles} data-sentry-element="Box" data-sentry-component="Footer" data-sentry-source-file="Footer.tsx">
			{footerData?.disclaimer && showDisclaimer && <Disclaimer disclaimer={footerData.disclaimer.disclaimer} dataTestId="footer_lite_disclaimer" disableGutters />}
			<Container sx={getContentWrapperStyles(onPatientServices)} maxWidth={false} data-sentry-element="Container" data-sentry-source-file="Footer.tsx">
				<Box data-test-id="section_footer_navigation_content" sx={getNavWrapperStyles} data-sentry-element="Box" data-sentry-source-file="Footer.tsx">
					<Container sx={getScheduleContainerStyles} data-test-id="section_footer_scheduling_content" data-sentry-element="Container" data-sentry-source-file="Footer.tsx">
						{footerLinks.map(link => <TAGLink key={link.link} openInNewTab={link.new_tab} href={link.link}>
								<Box sx={footerLinkTextBoxDesktopStyles}>
									<Typography lineHeight="1.5rem" color="text.light" variant="bodyLargeBold" justifyContent="flex-start">
										{link.title}
									</Typography>
								</Box>
							</TAGLink>)}
					</Container>
				</Box>

				<Typography variant="bodyMediumBook" color="text.light" sx={copyrightStyles} data-test-id="text_footer_copyright" data-sentry-element="Typography" data-sentry-source-file="Footer.tsx">
					{footerData?.copyright || ''}
				</Typography>

				{onPatientServices && <Box sx={contactUsWrapper}>
						<Typography color="text.light" variant="bodyMediumBook" textAlign="center">
							Need help with your patient account?
						</Typography>
						<TAGLink openInNewTab href={`https://www${environment === 'prod' ? '' : 'stg'}.aspendental.com/about/contact-us/`}>
							<Typography color="text.light" variant="bodyLargeBold" textAlign="center">
								Contact us
							</Typography>
						</TAGLink>
					</Box>}
				<Container data-test-id="section_footer_about" sx={getAboutWrapperStyles(onPatientServices)} data-sentry-element="Container" data-sentry-source-file="Footer.tsx">
					{footerData?.about?.json && <RichText content={footerData.about.json as RichTextContent} docProps={{
          color: 'text.light',
          variant: 'captionMedium',
          textAlign: 'center'
        }} />}
				</Container>
			</Container>
		</Box>;
}